const DIAGNOSIS_URL = 'https://products-eight-sand.vercel.app/';

const steps = [
  {
    number: '01',
    emoji: '📝',
    title: 'アンケートに回答',
    desc: '専用の診断フォームに回答いただきます。評価制度・人事制度の現状についてお答えください。',
    badge: '所要時間 約15分',
  },
  {
    number: '02',
    emoji: '📊',
    title: '診断レポート受領',
    desc: '5つの評価領域を学術理論に基づき分析。貴社の強みと課題を客観的にスコアリングします。',
    badge: '1週間以内に納品',
  },
  {
    number: '03',
    emoji: '💬',
    title: 'フィードバック面談',
    desc: '診断結果をもとに専門コンサルタントが丁寧にご説明。改善の優先順位と方向性をご提案します。',
    badge: '30〜60分（オンライン）',
  },
];

const phases = [
  { num: '01', label: '現状把握', icon: '🔍' },
  { num: '02', label: '制度設計', icon: '🏗️' },
  { num: '03', label: '導入', icon: '🚀' },
  { num: '04', label: '運用支援', icon: '⚙️' },
  { num: '05', label: '内製化', icon: '🌱' },
];

export default function HowItWorks() {
  return (
    <section
      id="flow"
      className="py-16"
      style={{ background: '#EEF4FB', fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      <div className="max-w-[1080px] mx-auto px-6">
        {/* Section Header */}

        <div className="text-center mb-12">
          <h2 className="text-2xl lg:text-[34px] font-bold text-[#1A1A2E] leading-tight">
            3ステップで診断完了
          </h2>
          <p className="text-[#667085] text-sm mt-2">まずは現状を知ることから</p>
        </div>

        {/* Steps */}
        <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-6 mb-12">
          {/* Connector Line (desktop only) */}
          <div className="hidden lg:block absolute top-[52px] left-[calc(16.67%+12px)] right-[calc(16.67%+12px)] h-px bg-[#D0DCF0] z-0"></div>

          {steps.map((step, index) => (
            <div
              key={index}
              className="relative z-10 bg-white rounded-xl p-7 flex flex-col items-center text-center"
              style={{ boxShadow: '0 4px 24px rgba(13,43,85,0.08)' }}
            >
              {/* Circle Icon */}
              <div
                className="w-16 h-16 rounded-full flex flex-col items-center justify-center mb-5 flex-shrink-0"
                style={{ background: '#0D2B55' }}
              >
                <span className="text-lg leading-none">{step.emoji}</span>
                <span className="text-[9px] text-white/60 font-medium mt-0.5">STEP {step.number}</span>
              </div>

              <h3 className="text-[#1A1A2E] text-base font-bold mb-3">{step.title}</h3>
              <p className="text-[#667085] text-sm leading-relaxed mb-4">{step.desc}</p>
              <span className="inline-block bg-[#EEF4FB] text-[#1A5CB0] text-sm font-medium px-3 py-1.5 rounded-full border border-[#D0DCF0]">
                ⏱ {step.badge}
              </span>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mb-12">
          <a
            href={DIAGNOSIS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#2D8EFF] text-white text-sm font-medium px-10 py-4 rounded-lg cursor-pointer whitespace-nowrap transition-all hover:bg-[#1A5CB0]"
            style={{ boxShadow: '0 4px 20px rgba(45,142,255,0.35)' }}
          >
            今すぐ無料診断を始める →
          </a>
        </div>

        {/* Paid Phase */}
        <div className="bg-white rounded-xl p-7" style={{ boxShadow: '0 4px 24px rgba(13,43,85,0.08)' }}>
          <div className="flex items-center gap-2 mb-5">
            <span className="text-base">📌</span>
            <h3 className="text-[#1A1A2E] text-sm font-bold">
              診断後の有償サポートフェーズ（ご希望の場合）
            </h3>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
            {phases.map((phase, index) => (
              <div
                key={index}
                className="bg-[#F7F9FC] rounded-lg px-4 py-4 flex flex-col items-center text-center"
              >
                <span className="text-xl mb-2">{phase.icon}</span>
                <span className="text-xs font-medium text-[#2D8EFF] mb-1">PHASE {phase.num}</span>
                <span className="text-sm font-bold text-[#1A1A2E]">{phase.label}</span>
              </div>
            ))}
          </div>
          <p className="text-[#667085] text-sm mt-4 text-center">
            無料診断後、ご希望の方には有償の人事制度構築支援サービスをご提案いたします。
          </p>
        </div>
      </div>
    </section>
  );
}
